import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, Signal, signal, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { AreasInterfaces } from '../interfaces/formulario.interfaces';

@Component({
  selector: 'app-areas-form',
  standalone: true,
  imports: [CommonModule, TooltipModule, FormsModule, InputTextModule],
  templateUrl: './areas-form.component.html',
  styleUrl: './areas-form.component.scss'
})
export class AreasFormComponent {
    @Input() titulo: string = '';
    @Input() tipo: 'forma' | 'formb' | 'formc' = 'forma';    
    @Input() areasGenerales: AreasInterfaces[] = [];
    @Input() areasForm: AreasInterfaces[] = [];
    @Input() tipoConstruccion!: Signal<boolean>;
    @Input() esValidaAreas: boolean = true;
    @Input() tooltip: string = 'Área debe ser menor que área de proyecto';
    @Input() readOnly: boolean = false;
    @Input() tramiteCompleto: boolean = false;
    @Input() mostrarPorcentaje: boolean = false;
    @Input() validarSuma: boolean = false;
    @Input() areaSignal!: WritableSignal<number>;
    @Input() isValidArea: boolean = false;
    
    @Input() areaActiva: () => number | null = () => 0;
    @Input() setAreaActiva: (valor: number) => void = () => {};
    @Input() setArea!: (valor: number) => void;
    @Input() calcularPorcentajeTotal: (area: number) => string = () => '';
    @Input() isValidarAreas: (tipoConstruccion: boolean) => boolean = () => false;

    @Output() onInput = new EventEmitter<void>();
    @Output() onBlur = new EventEmitter<{event: FocusEvent; area: AreasInterfaces}>();
    @Output() onBlurFc = new EventEmitter<{event: FocusEvent; area: number}>();
    @Output() onBlurFb = new EventEmitter<number>();
    @Output() onKeydown = new EventEmitter<KeyboardEvent>();
    onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).valueAsNumber;
      if (!isNaN(value)) {
          this.areaSignal.set(value);
      }
    }
}
